/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ObjectIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABXklEQVR4nM2UvUoDQRCATyOChYXiz0PY2was1Nz8XDHMnKQVtBYMNp5YCRb6AHY24jNYKWInioWVD2BlYaeisslGjD+5PeNBFqa45eb7dmaHjaJ+W0lSn3JRChzYNoDsxQWybv4vnLSBbG9fYkdEhnuG12pLY8j2/IPgWwDpE7LuFRKIyHiooClhfShcBbJtBwvI1gvB50UmkfU6UJAVgidJfQrJblrJ3SVAuoWIo3+Dk10B2HS3kwPYDJDex6wLuXARGQHWyzY8jtMJEan8dvI23H83cgXAutqC652De2klD96MxGoBAjvyCSvtvSzLBltz3tnzDjjZcRRFA7kCJD30ScsdYrJ9N+efR9H13LWFKF0MgnvQmhccRGUs5nTW38FtKYJqtToEZI/I9lra84xsJ66KmFIuS5D5e9gtRQCJzfnRu+gdxnYe+lrix8zrWbDA/VxUAGynPVfW9+sdUldLzaq20FIAAAAASUVORK5CYII=)
 */
export const ObjectIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.41 3.59 11.6 2.4a2 2 0 0 1 2.82 0l1.3 1.3a1 1 0 0 0 .7.29h4.18a1.41 1.41 0 0 1 1 2.41L14.4 13.6a1.41 1.41 0 0 1-2.41-1V8.4l-3.11 3.12a2 2 0 0 0-.53 1.87L9.9 20H15a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h4.86L6.4 13.86a4 4 0 0 1 1.06-3.75L10.8 6.8l-.38-.38a2 2 0 0 1 0-2.82Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.99 12.43c-.21.2-.2.55.06.7a3 3 0 0 0 4.08-4.08c-.15-.26-.5-.27-.7-.06l-3.44 3.44Z"
        className={colorClass}
      />
    </svg>
  );
};
